import React from "react";
import type { GateNudgeReason } from "../hooks/useGateNudge";
import "./GateNudge.css";

export function GateNudgeRings({ active, sequence }: { active: boolean; sequence: number }) {
  return active ? <span key={sequence} aria-hidden="true" className="gate-nudge-rings" /> : null;
}

export function GateNudgeAnnouncement({ reason, sequence }: { reason: GateNudgeReason | null; sequence: number }) {
  return <span className="sr-only" role="status" aria-live="polite" aria-atomic="true">
    <span key={sequence}>{reason === "cert" ? "Tick the box to continue." : reason === "email" ? "Enter your email to continue." : ""}</span>
  </span>;
}
